import { useState } from 'react'
import styled from 'styled-components'
import OrderlikeLayout from '../../../../../generic/Layouts/OrderlikeLayout'
import ControlSearchPannelLayout from '../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import SearchCustomers from '../../forcasts/Supply/Components/SearchCustomers'
import SearchInput from '../../../../../generic/inputs/inputSearch'
import FancyButton from '../../knisotLines/Components/FancyButton'
import QuotationTitleCard from './QuotationTitleCard'
import { useOrderQuotationTitles } from '../service/useOrderQuotationTitles'
import CustomBlockLoader from '../../knisot/generic/CustomBlockLoader'
import usePrint from '../../../../../generic/hooks/usePrint'
import { PdfPreview } from '../../../../../generic/ui/PdfPreview'
import { AppModal } from '../../../../../generic/ui/Modal'
import QuotationPrintCustomerModal from './QuotationPrintCustomerModal'
import { QUOTATION_PDF_URL } from '../constance/config'

const OrderQuotationTitles: React.FC = () => {

  const {
    filteredTitles,
    isLoading,
    searchInput,
    setSearchInput,
    customerID,
    setCustomerID,
    customerList,
    handleChangeStatus,
    handleNavigateToDetails,
    handleCreateNew,
    handleDeleteQuotation,
  } = useOrderQuotationTitles()
  const {
    file,
    handleSharePdf,
    handleDownloadPdf,
    handleClearFile,
    handleOpenPdf,
    handleGetPdf
  } = usePrint()

  const [printPending, setPrintPending] = useState<{ recId: number; customerId: number } | null>(null)

  const handlePrintClick = (recId: number, customerId: number) => {
    setPrintPending({ recId, customerId })
  }

  const handlePrintConfirm = (chosenCustomerID: number, customerFree: boolean) => {
    if (!printPending) return
    const url = `${QUOTATION_PDF_URL}/${printPending.recId}?CustomerID=${chosenCustomerID}&CustomerFree=${customerFree ? 1 : 0}`
    setPrintPending(null)
    handleGetPdf(url)
  }

  return (
    <OrderlikeLayout label="הצעות מחיר">
      {file && (
        <AppModal
          size='lg'
          title='תצוגה מקדימה'
          controlFunc={handleClearFile}
          Children={PdfPreview}
          childrenProps={{
            file,
            handleSharePdf,
            handleDownloadPdf,
            handleClearFile,
            handleOpenPdf,
          }}
        />
      )}
      <ControlSearchPannelLayout>
        <SearchCustomers
          list={customerList}
          defaultID={customerID}
          setCustomerID={setCustomerID}
          placeholder="חפש לפי לקוח"
        />
        <SearchInput
          input={searchInput}
          setInput={setSearchInput}
          value="חיפוש"
        />
      </ControlSearchPannelLayout>

      <ContentWrapper>
        {isLoading && (
          <CustomBlockLoader />
        )}
        {!isLoading && filteredTitles.length === 0 && (
          <EmptyMessage>לא נמצאו הצעות מחיר</EmptyMessage>
        )}
        {filteredTitles.map((item) => (
          <QuotationTitleCard
            key={item.recId}
            item={item}
            onStatusChange={handleChangeStatus}
            onClick={handleNavigateToDetails}
            onPrint={handlePrintClick}
            handleDeleteQuotation={handleDeleteQuotation}
          />
        ))}
      </ContentWrapper>

      <ButtonWrapper>
        <FancyButton onClick={handleCreateNew}>חדש</FancyButton>
      </ButtonWrapper>

      {printPending && (
        <AppModal
          size='sm'
          title='בחירת לקוח להדפסה'
          Children={QuotationPrintCustomerModal}
          childrenProps={{
            defaultCustomerID: printPending.customerId,
            onConfirm: handlePrintConfirm,
          }}
          controlFunc={() => setPrintPending(null)}
        />
      )}
    </OrderlikeLayout>
  )
}

export default OrderQuotationTitles

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  overflow-y: auto;
  padding: 0.25em 0;
  z-index: 1;

  &::-webkit-scrollbar {
    width: 0;
  }
`
const EmptyMessage = styled.p`
  text-align: center;
  color: #9ca3af;
  padding: 2em 0;
  font-size: 1em;
  z-index: 1;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5em 0;
  z-index: 1;
`
